export var DEVICE_CONNECTIVITY_EVENT='netInfo.networkStatusDidChange';
//# sourceMappingURL=privateTypes.js.map